<template>
    <div class="w-100">

        <div class="col-sm-12 d-flex flex-row mb-4">
            <button :class="{'bg-medium': reservation.transport.transfers.length != 1}" class="btn scondary mr-2" @click="setAsOneWay">One way</button>
            <button :class="{'bg-medium': reservation.transport.transfers.length != 2}" class="btn scondary mr-2" @click="setAsRoundTrip">Round trip</button>
            <button :class="{'bg-medium': reservation.transport.transfers.length != 0}" class="btn scondary" @click="setAsNoTransport">No transportation</button>
        </div>

        <!-- <div class="col-sm-12 d-flex flex-row mb-4">
            <radio name="transportType" :value="false" v-model="roundTrip" class="mr-4">
                One way
            </radio>
            <radio name="transportType" :value="true" v-model="roundTrip">
                Round trip
            </radio>
        </div> -->


        <div class="col-sm-12 row">

            <div class="col-sm-6 mb-4" v-for="transfer,index in reservation.transport.transfers">
                <div class="bg-lighter py-3">

                    <div class="col-sm-12 dark font-weight-600 justify-content-between d-flex">
                        <span>Custom <toggle-button v-model="transfer.isCustom" :labels="{checked: 'Yes', unchecked: 'No'}" @change="isCustomChange(transfer)" :disabled="readOnly" /></span>
                        <span class="dark py-1 px-2">{{(transfer.transportDirection == 1) ? 'Pickup' : 'Drop Off'}}</span>
                    </div>

                    <div class="col-sm-12 my-2" v-if="transfer.isCustom">
                        <span v-if="getCompanySettings.settingsPresets" class="darker font-weight-600">
                            {{getCompanySettings.settingsPresets.customRouteNote}}
                        </span>
                    </div>

                    <div v-if="!transfer.isCustom">

                        <div class="col-sm-12 mt-3" v-if="!roundTrip">
                            <label>Type</label>
                            <div class="d-flex">
                                <radio name="transportType" :value="1" v-model="transfer.transportDirection" @input="oneWayTypeChanged(transfer)" class="mr-4" :disabled="readOnly">
                                    Pickup
                                </radio>
                                <radio name="transportType" :value="2" v-model="transfer.transportDirection" @input="oneWayTypeChanged(transfer)" :disabled="readOnly">
                                    Drop off
                                </radio>
                            </div>
                        </div>


                        <div class="col-sm-12 mt-3">
                            <div class="d-flex flex-row justify-content-between">
                                <label>List</label>
                                <!-- <span class="color-1 fs-small underlined">Add custom</span> -->
                                <span v-if="transfer.errorRoute" class="color-6 fs-small">Invalid</span>
                            </div>
                            <v-select :options="routesByType(transfer.transportDirection)" v-model="transfer.route" label="name" @input="setExitStop($event, transfer)" :disabled="readOnly"></v-select>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.exitStop && transfer.transportDirection == 2">
                            <label>From</label>
                            <!-- <input type="text" class="d-block w-100" disabled :value="transfer.exitStop.name"> -->
                            <input type="text" class="d-block w-100 border-light px-2" disabled :value="iteneraryNiceOptions(transfer.route.id).length > 0? iteneraryNiceOptions(transfer.route.id)[0].name : null">
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.route && routes.length > 0">
                            <label>{{(transfer.transportDirection == 1) ? 'From' : 'To'}}</label>
                            <span v-if="transfer.errorStop" class="color-6 fs-small">Invalid</span>
                            <v-select :options="iteneraryNiceOptions(transfer.route.id)" v-model="transfer.stop" @input="setSelectedLocation(transfer)" label="name" :disabled="readOnly"></v-select>
                            <div class="mt-3" v-if="transfer.stop && transfer.stop.note">
                                <label>Note</label>
                                <div>{{transfer.stop.note}}</div>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.exitStop && transfer.transportDirection == 1">
                            <label>To</label>
                            <!-- <input type="text" class="d-block w-100" disabled :value="transfer.exitStop.name"> -->
                            <input type="text" class="d-block w-100 border-light px-2" disabled v-if="iteneraryNiceOptions(transfer.route.id)[iteneraryNiceOptions(transfer.route.id).length-1]" :value="iteneraryNiceOptions(transfer.route.id)[iteneraryNiceOptions(transfer.route.id).length-1].name">
                        </div>

                        <div class="d-flex">
                            <div class="col-sm-6 mt-3" v-if="transfer.stop">
                                <label>Time</label>
                                <span v-if="transfer.errorSchedule" class="color-6 fs-small">Invalid</span>
                                <v-select class="w-100" :options="possibleTimes(transfer)" v-model="transfer.schedule" @input="timeChanged(transfer)" label="timeShort" :disabled="readOnly"></v-select>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="transfer.schedule">
                                <label>Date</label>
                                <!-- <div class="font-weight-600 mt-2">{{transportDate}}</div> -->
                                <!-- <input type="text" class="d-block w-100" disabled :value="transportDate"> -->
                                <datepicker input-class="bg-lightest w-100" v-model="transfer.schedule.date" format="dd.MM.yyyy" @input="dateChanged($event, transfer)"></datepicker>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3" v-if="transfer.stop && transfer.stop.notes">
                            <label>Info</label>
                            <div>{{transfer.stop.notes}}</div>
                        </div>
                    </div>

                    <div v-if="transfer.isCustom" class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>From</label>
                                    <span v-if="transfer.errorRoute" class="color-6 fs-small">Invalid</span>
                                </div>
                                <input type="text" class="w-100" v-model="transfer.stop.name" :disabled="readOnly">
                            </div>

                            <div class="col-sm-12 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>To</label>
                                    <span v-if="transfer.errorStop" class="color-6 fs-small">Invalid</span>
                                </div>
                                <input type="text" class="w-100" v-model="transfer.exitStop.name" :disabled="readOnly">
                            </div>

                            <div class="col-sm-6 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Time</label>
                                    <span v-if="transfer.errorTime" class="color-6 fs-small">Invalid</span>
                                </div>
                                <!-- <input type="text" class="w-100" v-model="transfer.schedule.time"> -->
                                <timepicker :defaultTime="customHour(transfer)" @change="setCustomTime($event, transfer)"></timepicker>
                            </div>

                            <div class="col-sm-6 mt-3">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Date</label>
                                    <span v-if="transfer.errorDate" class="color-6 fs-small">Invalid</span>
                                </div>
                                <!-- <input type="text" class="w-100" v-model="transfer.schedule.date"> -->
                                <datepicker input-class="bg-lightest w-100" v-model="transfer.schedule.date" format="dd.MM.yyyy" @input="customDateChanged($event, transfer)"></datepicker>
                            </div>
                        </div>
                    </div>


                </div>


            </div>

        </div>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Timepicker from '@/tools/Timepicker'
import extendedVSelect from '@/extends/vue-select'
import {mapGetters, mapActions} from 'vuex'
export default {
    data: function() {
        return {
            // roundTrip: false,
            selectedRoute: null,
            selectedLocation: null,
            selectedSchedule: null,
            isCustomToggleVal: false,
            customTransportDefaultHour:[
                "10","00"
            ]
        }
    },
    created: function() {

        for (var i = 0; i < this.reservation.transport.transfers.length; i++) {
            this.$set(this.reservation.transport.transfers[i], 'errorRoute', false)
            this.$set(this.reservation.transport.transfers[i], 'errorTime', false)
            this.$set(this.reservation.transport.transfers[i], 'errorDate', false)
            this.$set(this.reservation.transport.transfers[i], 'errorStop', false)
            this.$set(this.reservation.transport.transfers[i], 'errorSchedule', false)
        }

        //we need supplier preset for the custom transpor messge, if we dont have that info we will init it
        if(!this.getCompanySettings.settingsPresets){
            this.initCompany()
        }

        if(this.reservation.transport.transfers.length == 0){
            this.setAsNoTransport();
        } else {
            // this.reservation.transport.transfers.map(transfer => {
            //     transfer.
            // })
        }


    },
    props:{
        routes: {
            type: Array,
            default: []
        },
        reservation: {
            type: Object
        },
        type: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: 'Transport'
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getCompanySettings'
        ]),
        // routesByType(): function() {
        //     return this.routes.filter(route => {
        //         return route.type == this.type
        //     })
        // },
        roundTrip: function() {
            return this.reservation.transport.transfers.length > 1
        },
        itenerariesByRoute: function(){
            if(this.transfer.route == null){
                return null
            }

            let outputArr = [];

            for(let itenerary of this.transfer.route.iteneraries){
                itenerary.stop.schedules = itenerary.schedules;
                outputArr.push(itenerary.stop)
            }

            this.transfer.exitStop = this.transfer.route.routeDestination

            return outputArr;
        },
        transportDate: function() {
            return moment(this.reservation.event.start).format("DD.MM.YYYY")
        }
    },
    methods: {
        ...mapActions([
            'initCompany'
        ]),
        isCustomChange: function(transfer){
            if(transfer.isCustom){
                transfer.route = null
                this.$set(transfer, 'errorRoute', false)
                this.$set(transfer, 'errorSchedule', false)
                this.$set(transfer, 'errorStop', false)

                this.$set(transfer, 'stop', {name:null})

                this.$set(transfer, 'exitStop', {name:null})

                this.$set(transfer, 'schedule', {date: null,time: this.customTransportDefaultHour[0]+':'+this.customTransportDefaultHour[1]+':00'})

                // transfer.isCustom = this.isCustomToggleVal
            } else {
                this.$set(transfer, 'errorRoute', false)
                this.$set(transfer, 'errorTime', false)
                this.$set(transfer, 'errorDate', false)
                this.$set(transfer, 'errorStop', false)

                this.$set(transfer, 'stop', null)

                this.$set(transfer, 'exitStop', null)

                this.$set(transfer, 'schedule', null)
                // transfer.isCustom = this.isCustomToggleVal
            }
        },
        routesByType: function(type) {
            return this.reservation.event.eventRoutes.filter(route => {
                return route.type == type
            })
        },
        addTransfer: function() {
            //old
            this.reservation.transport.transfers.push({
                order: 0,
                //date: this.transportDate,
                transportDirection: 1,
                isCustom: false,
                route: null,
                stop: null,
                exitStop: null,
                schedule: null,
            })
        },
        setAsOneWay: function(){
            if(this.readOnly){
                return false
            }

            // this.roundTrip = false;
            if(this.reservation.transport.transfers.length == 2){
                this.reservation.transport.transfers.splice(1,1)
            } else {
                this.reservation.transport.transfers = [
                    {
                        order: 0,
                        //date: this.transportDate,
                        transportDirection: 1,
                        isCustom: false,
                        route: null,
                        stop: null,
                        exitStop: null,
                        schedule: null,
                    }
                ]
            }
        },
        setAsRoundTrip: function(){
            if(this.readOnly){
                return false
            }

            // this.roundTrip = true;
            if(this.reservation.transport.transfers.length == 0){
                //creates 2 transfer with different directions
                this.reservation.transport.transfers = [
                    {
                        order: 0,
                        //date: this.transportDate,
                        transportDirection: 1,
                        isCustom: false,
                        route: null,
                        stop: null,
                        exitStop: null,
                        schedule: null,
                    },
                    {
                        order: 0,
                        //date: this.transportDate,
                        transportDirection: 2,
                        isCustom: false,
                        route: null,
                        stop: null,
                        exitStop: null,
                        schedule: null,
                    }
                ]
            } else if(this.reservation.transport.transfers.length == 1) {
                if(this.reservation.transport.transfers[0].transportDirection == 2){
                    this.resetTransfer(0, 1)
                }
                this.reservation.transport.transfers.push(
                    {
                        order: 0,
                        //date: this.transportDate,
                        transportDirection: 2,
                        isCustom: false,
                        route: null,
                        stop: null,
                        exitStop: null,
                        schedule: null,
                    }
                )
            }
        },
        resetTransfer: function(transferIndex, transportDirection) {
            this.reservation.transport.transfers[transferIndex] = {
                order: 0,
                //date: this.transportDate,
                transportDirection: transportDirection,
                isCustom: false,
                route: null,
                stop: null,
                exitStop: null,
                schedule: null,
            }
        },
        setAsNoTransport: function(){
            if(this.readOnly){
                return false
            }

            // this.roundTrip = false;
            this.reservation.transport.transfers = []
        },
        removeTransfer: function(index) {
            //old
            this.reservation.transport.transfers.splice(index, 1)
        },
        iteneraryNiceOptions: function(routeId) {
            if(routeId == null){
                return null
            }

            let selectedRoute = this.routes.filter(route => {
                return routeId == route.id
            })[0]

            if(!selectedRoute){
                return []
            }


            let possibleStops = []

            for(let itenerary of selectedRoute.iteneraries){
                let possibleStop = itenerary.stop
                possibleStop.note = itenerary.note
                possibleStops.push(possibleStop)
            }

            // for(let itenerary of selectedRoute.iteneraries) {
            //     this.$set(itenerary, 'name', itenerary.stop.name)
            // }

            return possibleStops
        },
        setExitStop: function($event, transfer) {
            console.log('triggered setExitStop', transfer);
            if(!transfer || this.routes.length == 0){
                return []
            }




            if(transfer.transportDirection == 1){
                if(transfer.route){
                    transfer.exitStop = transfer.route.routeDestination
                } else {
                    transfer.exitStop = null
                    transfer.stop = null
                    transfer.schedule = null
                    return false
                }
            } else if (transfer.transportDirection == 2) {
                if(transfer.route){
                    transfer.exitStop = transfer.route.routeDestination
                } else {
                    transfer.exitStop = null
                    transfer.stop = null
                    transfer.schedule = null
                    return false
                }
                transfer.exitStop = this.findAvailableRouteById(transfer.route.id).iteneraries[0].stop
            }

            // check if current selected stop is valid for selected route, if not clears it
            let selectedRouteIteneraries = this.findAvailableRouteById(transfer.route.id).iteneraries
            let findStopInIteneraries = selectedRouteIteneraries.filter(itenerary => {
                if(transfer.stop){
                    return itenerary.stop.id == transfer.stop.id
                }
            })

            if(findStopInIteneraries.length == 0){
                transfer.stop = null
            }

            this.$forceUpdate() // just a patch


        },
        setSelectedLocation: function(transfer) {
            // delets hour if a pickup location is changed
            // if(transfer.transportDirection == 1){
            //     transfer.schedule = null
            // }
            this.$forceUpdate()

        },
        setCustomTime: function($event, transfer) {
            transfer.schedule.time = $event+':00'
            transfer.schedule.timeShort = $event

            // updates date
            let date = transfer.schedule.date.split(' ')[0]
            transfer.schedule.date = date + ' ' + transfer.schedule.time
            transfer.schedule.dateTimeLong = transfer.schedule.date

        },
        findAvailableRouteById: function(routeId) {
            return this.routes.filter(route => {
                return routeId == route.id
            })[0]
        },
        possibleTimes: function(transfer) {
            if(!transfer || this.routes.length == 0 || !transfer.route){
                return []
            }

            let routeId = transfer.route.id

            let selectedRoute = this.routes.filter(route => {
                return routeId == route.id
            })[0]

            if(!selectedRoute){
                return []
            }


            if(transfer.transportDirection == 1){
                // is pickup so shows the times for the selectedStop
                var selectedStop = selectedRoute.iteneraries.filter(itenerary => {
                    return transfer.stop.id == itenerary.stop.id
                })[0]
            } else if(transfer.transportDirection == 2) {
                // is drop off so shows the times for the fist stop (here the passager enters for the dropoff)
                var selectedStop = selectedRoute.iteneraries[0]
            }

            return selectedStop.schedules
            // return []
        },
        customHour: function(transfer) {
            if(transfer.schedule.timeShort){
                return transfer.schedule.timeShort.split(":")
            } else {
                return this.customTransportDefaultHour
            }
        },
        customDateChanged: function(e, transfer) {
            transfer.schedule.date = moment(e).format('YYYY-MM-DD HH:mm:ss')
        },
        dateChanged: function(e, transfer) {
            let dateString = moment(e).format('YYYY-MM-DD') + ' ' + transfer.schedule.time
            transfer.date = dateString
            transfer.schedule.date = dateString
        },
        oneWayTypeChanged: function(transfer) {
            if(transfer.transportDirection == 1){
                // is pickup
                transfer.route = null
                transfer.exitStop = null
                transfer.schedule = null
            } else {
                // is dropoff
                transfer.route = null
                transfer.exitStop = null
                transfer.schedule = null

            }
        },
        timeChanged: function (transfer) {
            if(!transfer.date){
                transfer.schedule.date = moment(this.reservation.event.start).format('YYYY-MM-DD') + ' ' + transfer.schedule.time
            } else {
                let currentDate = transfer.date.split(" ")[0]
                transfer.schedule.date = currentDate + ' ' + transfer.schedule.time

            }

            this.$forceUpdate()
        }
    },
    components: {
        vSelect: extendedVSelect,
        Datepicker,
        Timepicker
    }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/_variables.scss';

input[disabled]{
    color: $dark !important;
    // background: none;
    // border: none;
    // padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// RouteForm.vue?4d9675d5